const scryptednodepty = __non_webpack_require__('@scrypted/node-pty'); module.exports = scryptednodepty;